// 负责广告点击追踪
// iframe 相关的事件监听
// 页面可见性变化追踪
export default {
	data() {
		return {
			activeIframe: null,
			iframes: new Map(),
			visibilityChangeHandler: null,
			blurHandler: null,
		}
	},

	methods: {
		initAdTracking() {
			if (typeof window === 'undefined') return
			console.log('[AdTracking] 🚀 初始化点击追踪')

			this.watchForIframeInsertion()
			this.setupVisibilityTracking()
			this.setupBlurTracking()
		},

		watchForIframeInsertion() {
			// console.log('[AdTracking] 监听iframe插入')
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType !== 1) {
							return
						}
						if (node.tagName === 'IFRAME' && node.closest('ins.adsbygoogle')) {
							// console.log('[AdTracking] ifame 广告已经检测:', node)
							this.setupIframeTracking(node)
						} else {
							const iframesInNode = node.querySelectorAll('iframe')
							iframesInNode.forEach((iframe) => {
								if (iframe.closest('ins.adsbygoogle')) {
									// console.log('[AdTracking] ifame 广告已经检测 子集:', iframe)
									this.setupIframeTracking(iframe)
								}
							})
						}
					})
				})
			})

			observer.observe(document.body, {
				childList: true,
				subtree: true,
			})
		},

		setupIframeTracking(iframe) {
			if (this.iframes.has(iframe)) return

			const adSlot = iframe.closest('ins.adsbygoogle')?.dataset.adSlot
			console.log(`[AdTracking] 👁️ 追踪 Iframe | Slot: ${adSlot}`)
			this.iframes.set(iframe, {
				hasTracked: false,
				adSlot: adSlot,
			})
		},

		setupBlurTracking() {
			// console.log('[AdTracking] 焦点丢失监听')
			this.blurHandler = () => {
				if (document.activeElement && document.activeElement.tagName === 'IFRAME' && this.iframes.has(document.activeElement)) {
					// console.log('[AdTracking] 焦点丢失:', document.activeElement)
					this.handleIframeFocus(document.activeElement)
				}
			}
			window.addEventListener('blur', this.blurHandler)
		},

		handleIframeFocus(iframe) {
			// console.log('[AdTracking] 焦点获取:', iframe)
			const data = this.iframes.get(iframe)
			if (data && !data.hasTracked) {
				console.log(`[AdTracking] 🖱️ 捕获点击 | Slot: ${data.adSlot}`)
				this.trackAdClick(iframe)
				data.hasTracked = true
				this.activeIframe = iframe
			}
		},

		trackAdClick(iframe) {
			const container = iframe.closest('ins.adsbygoogle')
			if (!container) return

			const rect = container.getBoundingClientRect()
			const clickData = {
				insX: rect.left,
				insY: rect.top,
				insHeight: rect.height,
				windowWidth: window.innerWidth,
				windowHeight: window.innerHeight,
				adSlot: container.dataset.adSlot,
			}
			// console.log('[AdTracking] 广告点击数据:', clickData)

			this.$adClick?.(JSON.stringify(clickData))
			this.$adTelemetryV2?.('click', 'adTrackingMixin_trackAdClick', {
				adSlot: clickData.adSlot,
			})
			this.$eventrack?.('ad_iframe_click', 'click', {
				'data-ad-slot': clickData.adSlot,
			})
		},

		setupVisibilityTracking() {
			// console.log('[AdTracking] 页面可见性变化监听?>>')
			this.visibilityChangeHandler = () => {
				// console.log(`[AdTracking] Visibility changed to: ${document.visibilityState}`)
				if (document.visibilityState === 'visible') {
					this.activeIframe = null
				} else if (this.activeIframe) {
					const data = this.iframes.get(this.activeIframe)
					console.log(`[AdTracking] 👋 页面离开 (点击后) | Slot: ${data?.adSlot}`)
					this.$eventrack?.('ad_iframe_click_leave', 'click', {
						'data-ad-slot': data?.adSlot,
					})
					this.$adTelemetryV2?.('pagehide', 'adTrackingMixin_click_leave', {
						adSlot: data?.adSlot,
					})
				}
			}

			document.addEventListener('visibilitychange', this.visibilityChangeHandler)
		},

		cleanupAdTracking() {
			console.log('[AdTracking] 🧹 清理资源')
			if (this.visibilityChangeHandler) {
				document.removeEventListener('visibilitychange', this.visibilityChangeHandler)
			}
			if (this.blurHandler) {
				window.removeEventListener('blur', this.blurHandler)
			}
			this.iframes.clear()
			this.activeIframe = null
		},
	},

	beforeDestroy() {
		this.cleanupAdTracking()
	},
}
